import { Button, Space, PasswordInput, Text } from "@mantine/core";
import { useState } from "react";
import useAuthStore from "../../store/useAuthStore";
import { useNavigate } from "react-router";
import useReportStore from "../../store/useReportStore";
import useCoursesStore from "../../store/useCoursesStore";
import useDashboardStore from "../../store/useDashboardStore";
import useProfileStore from "../../store/useProfileStore";
import useDevelopmentStore from "../../store/useDevelopmentStore";
import { useTranslation } from "react-i18next";

export const DeleteAccount = ({
  passwordRequired,
}: {
  passwordRequired: boolean;
}) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { deleteAccount, access_token } = useAuthStore();
  const navigate = useNavigate();

  const { resetReportState } = useReportStore();
  const { resetCoursesState } = useCoursesStore();
  const { resetDashboardState } = useDashboardStore();
  const { resetProfileState } = useProfileStore();
  const { resetDevelopmentState } = useDevelopmentStore();

  const { t } = useTranslation();

  const handleDeleteAccount = async () => {
    setLoading(true);
    setError(null);

    try {
      const successDelete = await deleteAccount(access_token, password);
      if (successDelete) {
        resetCoursesState();
        resetReportState();
        resetDashboardState();
        resetProfileState();
        resetDevelopmentState();
        navigate("/auth/sign-up");
      } else {
        setError(t("incorrectPassword"));
        setLoading(false);
      }
    } catch (error) {
      console.error("Delete error:", error);
      setError(t("somethingWentWrong"));
      setLoading(false);
    }
  };

  return (
    <div>
      {passwordRequired && (
        <PasswordInput
          label={t("enterYourPassword")}
          placeholder={t("password")}
          value={password}
          onChange={(e) => setPassword(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleDeleteAccount();
            }
          }}
        />
      )}

      {error && (
        <Text color="red" size="sm">
          {error}
        </Text>
      )}

      <Space h="20px" />

      <Button
        fullWidth
        color="red"
        loading={loading}
        onClick={handleDeleteAccount}
        disabled={passwordRequired && !password}
      >
        {t("deleteAccount")}
      </Button>
    </div>
  );
};
